/**
 * @file FormModel Controller
 */

'use strict';
import Listener from '../Utils/Listener';
import Common from '../Utils/Common';
import Template from '../Template/Template';

let instance = null;

/**
 * @classname FormModel
 * @classdesc Basic Model
 */
export default class FormModel {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}

		this._listener = new Listener();
		this._jqXHR = null;
		this._post = false;
		this._data = null;
		this._message = null;
		this._code = null;
		this._detailPage = false;

		// csrf add
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});

		instance = this;
		return instance;
	};


	/**
	 *
	 * 写真アップロード
	 * @memberof FormModel
	 * @param {blob} file - ファイル
	 * @param {integer} userId - ユーザーID
	 * @return {undefined}
	 */
	uploadPhoto(file, userId) {
		if (this._post) return;
		console.log(`FormModel.uploadPhoto`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('photofile', file);
		formData.append('user_id', userId);
		const url = window.const.API_URL.UPLOAD_PHOTO;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onUploadPhotoComplete.bind(this));
	};


	/**
	 * 画像アップロードajax通信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onUploadPhotoComplete(data, textStatus) {
		console.log('FormModel.onUploadPhotoComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('uploadPhotoComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onUploadPhotoComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *
	 * かんたん団検索
	 * @memberof FormModel
	 * @param {string} groupName - 団名
	 * @return {undefined}
	 */
	groupEasySearch(groupName) {
		if (this._post) return;
		console.log(`FormModel.groupEasySearch`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_name', groupName);
		const url = window.const.API_URL.GROUP_EASY_SEARCH;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGroupEasySearchComplete.bind(this));
	};


	/**
	 * かんたん団検索ajax通信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGroupEasySearchComplete(data, textStatus) {
		console.log('FormModel.onGroupEasySearchComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('groupEasySearchComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (groupEasySearchComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *
	 * かんたん団検索2
	 * @memberof FormModel
	 * @param {string} groupName - 団名
	 * @return {undefined}
	 */
	groupEasySearch2(groupName) {
		if (this._post) return;
		console.log(`FormModel.groupEasySearch2`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_name', groupName);
		const url = window.const.API_URL.GROUP_EASY_SEARCH2;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGroupEasySearchComplete.bind(this));
	};


	/**
	 * かんたん団検索2ajax通信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGroupEasySearch2Complete(data, textStatus) {
		console.log('FormModel.onGroupEasySearch2Complete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('groupEasySearch2Complete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (groupEasySearchComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *
	 * かんたん団検索地区団取得
	 * @memberof FormModel
	 * @param {string} groupId - 団ID
	 * @return {undefined}
	 */
	getEasySearchDistrictsGroups(groupId) {
		if (this._post) return;
		console.log(`FormModel.getEasySearchDistrictsGroups`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_id', groupId);
		const url = window.const.API_URL.GET_EASY_SEARCH_DISTRICTS_GROUPS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetEasySearchDistrictsGroups.bind(this));
	};


	/**
	 * かんたん団検索地区団取得ajax通信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetEasySearchDistrictsGroups(data, textStatus) {
		console.log('FormModel.onGetEasySearchDistrictsGroups');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('onGetEasySearchDistrictsGroupsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetEasySearchDistrictsGroups): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *
	 * 仮パスワード設定
	 * @memberof FormModel
	 * @return {undefined}
	 */
	setTmpPassword() {
		if (this._post) return;
		console.log(`FormModel.groupEasySearch2`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		const memberId = $('#tmp_issue_password_member_no').val();
		console.log(memberId)
		console.log($('#password').val());
		console.log($('#password_confirmation').val());
		formData.append('member_no', memberId);
		formData.append('password', $('#password').val());
		formData.append('password_confirmation', $('#password_confirmation').val());
		const url = window.const.API_URL.SET_TMP_PASSWORD;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onSetTmpPasswordComplete.bind(this));
	};


	/**
	 * 仮パスワード設定完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onSetTmpPasswordComplete(data, textStatus) {
		console.log('FormModel.onSetTmpPasswordComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		$('#modal-tmp-password .close').click();

		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				$('#modal-password-error .text').text(this._message);
				const errorModal = new bootstrap.Modal(document.getElementById('modal-password-error'));
				errorModal.show();
			} else {
				this._post = false;
				$('#modal-password-success .text').text(this._message);
				const successModal = new bootstrap.Modal(document.getElementById('modal-password-success'));
				successModal.show();
				this._listener.trigger('onSetTmpPasswordComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (groupEasySearchComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 操作担当者取得
	 *
	 * @memberof FormModel
	 * @param {number} councilId - 県連盟ID
	 * @return {undefined}
	 */
	getOperators(councilId) {
		if (this._post) return;
		console.log(`FormModel.getOperators`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		const url = window.const.API_URL.GET_OPERATORS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetOperatorsComplete.bind(this));
	};


	/**
	 * 操作担当者取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetOperatorsComplete(data, textStatus) {
		console.log('FormModel.onGetOperatorsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getOperatorsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetDistrictsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 地区リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} councilId - 県連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistricts(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getDistricts`);
		console.log(dormantFlg);
		Common.showLoading();
		this._post = true;
		if ($('#show_inactive_groups').prop('checked')) dormantFlg = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		console.log(formData.get('district_id'));
		console.log(formData.get('get_dormant'));
		Common.logFormData(formData);
		const url = window.const.API_URL.GET_DISTRICTS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetDistrictsComplete.bind(this));
	};


	/**
	 * 地区リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetDistrictsComplete(data, textStatus) {
		console.log('FormModel.onGetDistrictsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getDistrictsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetDistrictsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 地区リスト・所属リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} councilId - 県連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsAffiliations(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getDistrictsAffiliations`);
		Common.showLoading();
		this._post = true;
		if ($('#show_inactive_groups').prop('checked')) dormantFlg = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		Common.logFormData(formData);
		const url = window.const.API_URL.GET_DISTRICTS_AFFILIATIONS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetDistrictsAffiliationsComplete.bind(this));
	};


	/**
	 * 地区リスト・所属リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetDistrictsAffiliationsComplete(data, textStatus) {
		console.log('FormModel.onGetDistrictsAffiliationsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getDistrictsAffiliationsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetDistrictsAffiliationsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 地区リスト・団リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} councilId - 県連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsGroups(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getDistrictsGroups`);
		Common.showLoading();
		this._post = true;
		if ($('#show_inactive_groups').prop('checked')) dormantFlg = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		Common.logFormData(formData);
		const url = window.const.API_URL.GET_DISTRICTS_GROUPS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetDistrictsGroupsComplete.bind(this));
	};


	/**
	 * 地区リスト・団リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetDistrictsGroupsComplete(data, textStatus) {
		console.log('FormModel.onGetDistrictsGroupsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getDistrictsGroupsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetDistrictsGroupsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 地区リスト・団リスト・所属リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} councilId - 県連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsGroupsAffiliations(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getDistrictsGroupsAffiliations`);
		Common.showLoading();
		this._post = true;
		if ($('#show_inactive_groups').prop('checked')) dormantFlg = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		Common.logFormData(formData);
		const url = window.const.API_URL.GET_DISTRICTS_GROUPS_AFFILIATIONS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetDistrictsGroupsAffiliationsComplete.bind(this));
	};


	/**
	 * 地区リスト・所属リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetDistrictsGroupsAffiliationsComplete(data, textStatus) {
		console.log('FormModel.onGetDistrictsGroupsAffiliationsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getDistrictsGroupsAffiliationsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetDistrictsGroupsAffiliationsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 団リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} districtId - 地区ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroups(districtId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getGroups`);
		console.log(dormantFlg);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('district_id', districtId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		console.log('hoge');
		console.log(formData.get('district_id'));
		console.log(formData.get('get_dormant'));
		const url = window.const.API_URL.GET_GROUPS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupsComplete.bind(this));
	};


	/**
	 * 団リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupsComplete(data, textStatus) {
		console.log('FormModel.onGetGroupsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 団リスト・所属リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} districtId - 地区ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsAffiliations(districtId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getGroupsAffiliations`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('district_id', districtId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		const url = window.const.API_URL.GET_GROUPS_AFFILIATIONS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupsAffiliationsComplete.bind(this));
	};


	/**
	 * 団リスト・所属リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupsAffiliationsComplete(data, textStatus) {
		console.log('FormModel.onGetGroupsAffiliationsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupsAffiliationsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupsAffiliationsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 団リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsFromCouncil(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getGroupsFromCouncil`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		const url = window.const.API_URL.GET_GROUPS_FROM_COUNCIL;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupsFromCouncilComplete.bind(this));
	};


	/**
	 * 団リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupsFromCouncilComplete(data, textStatus) {
		console.log('FormModel.onGetGroupsFromCouncilComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupsFromCouncilComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupsFromCouncilComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 団リスト・所属リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsAffiliationsFromCouncil(councilId, dormantFlg) {
		if (this._post) return;
		console.log(`FormModel.getGroupsAffiliationsFromCouncil`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('council_id', councilId);
		if (dormantFlg === true) formData.append('get_dormant', true);
		const url = window.const.API_URL.GET_GROUPS_AFFILIATIONS_FROM_COUNCIL;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupsAffiliationsFromCouncilComplete.bind(this));
	};


	/**
	 * 団リスト・所属リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupsAffiliationsFromCouncilComplete(data, textStatus) {
		console.log('FormModel.onGetGroupsAffiliationsFromCouncilComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupsAffiliationsFromCouncilComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupsAffiliationsFromCouncilComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 所属リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} groupId - 団ID
	 * @return {undefined}
	 */
	getAffiliations(groupId) {
		if (this._post) return;
		console.log(`FormModel.getAffiliations`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_id', groupId);
		const url = window.const.API_URL.GET_AFFILIATIONS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetAffiliationsComplete.bind(this));
	};


	/**
	 * 従登録用 所属リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} groupId - 団ID
	 * @return {undefined}
	 */
	getAffiliationsAdditional(groupId) {
		if (this._post) return;
		console.log(`FormModel.getAffiliationsAdditional`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_id', groupId);
		const url = window.const.API_URL.GET_AFFILIATIONS_ADDITIONAL;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetAffiliationsComplete.bind(this));
	};


	/**
	 * 所属リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetAffiliationsComplete(data, textStatus) {
		console.log('FormModel.onGetAffiliationsComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getAffiliationsComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetAffiliationsComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 役務リスト取得
	 * 
	 * @memberof FormModel
	 * @param {number} affiliationId - 所属ID
	 * @return {undefined}
	 */
	getTitles(affiliationId) {
		if (this._post) return;
		console.log(`FormModel.getTitles`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('affiliation_id', affiliationId);
		const url = window.const.API_URL.GET_TITLES;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetTitlesComplete.bind(this));
	};


	/**
	 * 従登録 役務リスト取得
	 *
	 * @memberof FormModel
	 * @param {number} affiliationId - 所属ID
	 * @return {undefined}
	 */
	getTitlesAdditional(affiliationId) {
		if (this._post) return;
		console.log(`FormModel.getTitlesAdditional`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('affiliation_id', affiliationId);
		const url = window.const.API_URL.GET_TITLES_ADDITIONAL;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetTitlesComplete.bind(this));
	};


	/**
	 * 役務リスト取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetTitlesComplete(data, textStatus) {
		console.log('FormModel.onGetTitlesComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getTitlesComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetTitlesComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * データ紐付け
	 * 
	 * @memberof FormModel
	 * @param {number} memberId - 加盟員No.
	 * @return {undefined}
	 */
	linkData(memberId) {
		if (this._post) return;
		console.log(`FormModel.linkData`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('member_id', memberId);
		const url = window.const.API_URL.LINK_DATA;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onLinkDataComplete.bind(this));
	};


	/**
	 * データ紐付け完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onLinkDataComplete(data, textStatus) {
		console.log('FormModel.onLinkDataComplete');
		Common.hideLoading();
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('linkDataComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onLinkDataComplete): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 加盟員Noから会員情報を取得
	 * 
	 * @memberof FormModel
	 * @param {number} memberId - 加盟員No.
	 * @return {undefined}
	 */
	getMemberData(memberId) {
		if (this._post) return;
		console.log(`FormModel.getMemberData`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('member_id', memberId);
		const url = window.const.API_URL.GET_MEMBER_DATA;
		console.log(url);
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetMemberData.bind(this));
	};


	/**
	 * 加盟員Noから会員情報を取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetMemberData(data, textStatus) {
		console.log('FormModel.onGetMemberData');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getMemberDataComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetMemberData): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 連盟・地区・団IDから会員情報を取得
	 * 
	 * @memberof FormModel
	 * @param {number} ids - 連盟・地区・団ID
	 * @return {undefined}
	 */
	getGroupCommitteeChairman(ids) {
		if (this._post) return;
		console.log(`FormModel.getGroupCommitteeChairman`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('council_id', ids.council_id);
		formData.append('district_id', ids.district_id);
		formData.append('group_id', ids.group_id);
		const url = window.const.API_URL.GET_GROUP_COMMITTEE_CHAIRMAN_DATA;
		console.log(url);
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupCommitteeChairman.bind(this));
	};


	/**
	 * 加盟員Noから会員情報を取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupCommitteeChairman(data, textStatus) {
		console.log('FormModel.onGetGroupCommitteeChairman');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupCommitteeChairmanComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupCommitteeChairman): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 加盟員検索
	 * 
	 * @memberof FormModel
	 * @param queryParameters - { [key: string]: number | null }
	 * @return {undefined}
	 */
	searchMember(queryParameters) {
		if (this._post) return;
		console.log(`FormModel.searchMember`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		for (const property in queryParameters) { formData.append(property, queryParameters[property]) }
		Common.logFormData(formData)
		const url = window.const.API_URL.SEARCH_MEMBER_FROM_ACCIDENT;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onSearchMember.bind(this));
	};


	/**
	 * 加盟員検索
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onSearchMember(data, textStatus) {
		console.log('FormModel.onSearchMember');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('searchMemberComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onSearchMember): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 各画面共通の加盟員検索
	 * 
	 * @memberof FormModel
	 * @param queryParameters - { [key: string]: number | null }
	 * @return {undefined}
	 */
	commonSearchMember(queryParameters, endpoint) {
		if (this._post) return;
		console.log(`FormModel.commonSearchMember`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		for (const property in queryParameters) { formData.append(property, queryParameters[property]) }
		Common.logFormData(formData)
		const url = endpoint;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onCommonSearchMember.bind(this));
	};


	/**
	 * 各画面共通の加盟員検索完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onCommonSearchMember(data, textStatus) {
		console.log('FormModel.onCommonSearchMember');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('commonSearchMemberComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onCommonSearchMember): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 加盟員検索モーダルで選択した人のデータ取得
	 * 
	 * @memberof FormModel
	 * @param {number} userId - ユーザーID
	 * @return {undefined}
	 */
	getMemberDataFromMemberSearchModal(userId) {
		if (this._post) return;
		console.log(`FormModel.getMemberDataFromMemberSearchModal`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('user_profile_id', userId)
		const url = window.const.API_URL.GET_MEMBER_DATA_FROM_MEMBER_SEARCH_MODAL;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetMemberDataFromMemberSearchModal.bind(this));
	};


	/**
	 * 加盟員検索モーダルで選択した人のデータ取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetMemberDataFromMemberSearchModal(data, textStatus) {
		console.log('FormModel.onGetMemberDataFromMemberSearchModal');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getMemberDataFromMemberSearchModalComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetMemberDataFromMemberSearchModal): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *  団IDから団委員長情報を取得
	 * 
	 * @memberof FormModel
	 * @param {number} groupId - 団ID
	 * @return {undefined}
	 */
	getGroupCommitteeChairman(groupId) {
		if (this._post) return;
		console.log(`FormModel.getGroupCommitteeChairman`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_id', groupId)
		const url = window.const.API_URL.GET_GROUP_COMMITTEE_CHAIRMAN;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetGroupCommitteeChairman.bind(this));
	};


	/**
	 *  団IDから団委員長情報を取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetGroupCommitteeChairman(data, textStatus) {
		console.log('FormModel.onGetGroupCommitteeChairman');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getGroupCommitteeChairmanComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetGroupCommitteeChairman): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 追加・非表示の操作が可能なマスタメンテナンスの更新
	 * 
	 * @memberof FormModel
	 * @param {FormData} formData - フォームデータ
	 * @param {string} action - actionのURL
	 * @return {undefined}
	 */
	updateMasterMaintenance(formData, action) {
		if (this._post) return;
		console.log(`FormModel.updateMasterMaintenance`);
		Common.showLoading();
		this._post = true;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = action;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onUpdateMasterMaintenance.bind(this));
	};


	/**
	 *  追加・非表示の操作が可能なマスタメンテナンスの更新完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onUpdateMasterMaintenance(data, textStatus) {
		console.log('FormModel.onUpdateMasterMaintenance');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				Common.showCompleteModal('更新が完了しました。');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onUpdateMasterMaintenance): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 日本連盟役務マスタメンテナンスの更新
	 * 
	 * @memberof FormModel
	 * @param {FormData} formData - フォームデータ
	 * @return {undefined}
	 */
	updateMasterMaintenanceTitle(formData) {
		if (this._post) return;
		console.log(`FormModel.updateMasterMaintenanceTitle`);
		Common.showLoading();
		this._post = true;
		let params = {};
		const url = window.const.API_URL.UPDATE_MASTER_MAINTENANCE_TITLE;
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onUpdateMasterMaintenanceTitle.bind(this));
	};


	/**
	 *  日本連盟役務マスタメンテナンスの更新完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onUpdateMasterMaintenanceTitle(data, textStatus) {
		console.log('FormModel.onUpdateMasterMaintenanceTitle');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				Common.showCompleteModal('更新が完了しました。');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onUpdateMasterMaintenanceTitle): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 *  サポーターを団に登録する画面で必要なデータをフェッチ
	 * 
	 * @memberof FormModel
	 * @param {number} groupId - 団ID
	 * @return {undefined}
	 */
	registerSupporter(groupId) {
		if (this._post) return;
		console.log(`FormModel.registerSupporter`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('group_id', groupId)
		const url = window.const.API_URL.GET_SCOUTS;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onRegisterSupporter.bind(this));
	};


	/**
	 *  サポーターを団に登録する画面で必要なデータをフェッチ完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onRegisterSupporter(data, textStatus) {
		console.log('FormModel.onRegisterSupporter');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('registerSupporterComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onRegisterSupporter): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * multipart/form-data で送信
	 * 
	 * @memberof FormModel
	 * @param {jQuery} $form
	 * @param {formData} formData
	 * @param {string | null} confirmationModalId
	 * @return {undefined}
	 */
	submitMultipartFormData($form, formData, confirmationModalId) {
		console.log(`FormModel.submitMultipartFormData`)
		let params = {
			url: $form.attr('action'),
			data: formData,
			method: 'POST',
			contentType: false,
			processData: false,
		}
		console.log(params)

		/**
		 * 確認モーダルが立ち上がっている場合は閉じてから処理を進める
		 * @param {function} callback 
		 */
		const closeConfirmationModal = (callback) => {
			if (confirmationModalId) {
				const confirmationModalElement = document.getElementById(confirmationModalId)
				const confirmationModal = bootstrap.Modal.getInstance(confirmationModalElement)
				confirmationModal.hide()
				confirmationModalElement.addEventListener('hidden.bs.modal', () => callback(), { once: true })
			} else {
				callback()
			}
		}

		$.ajax(params)
			.done(response => {
				closeConfirmationModal(() => {
					this.callbackOnSucceededAjaxRequest(response)
				})
			})
			.fail((jqXHR, response, textStatus, errorThrown) => {
				closeConfirmationModal(() => {
					this.callbackOnFailedAjaxRequest(jqXHR, textStatus, errorThrown)
				})
			})
			.always(() => {
				this._post = false
				// clicked classの削除
				$('button[data-multipart-form-data]').removeClass('clicked')
			})
	}


	/**
	 * ファイル出力
	 * 
	 * @memberof FormModel
	 * @param {jQuery} $form
	 * @param {formData} formData
	 * @param {string} prefix
	 * @return {undefined}
	 */
	submitDataForOutputFiles($form, formData, prefix) {
		console.log(`FormModel.submitDataForOutputFiles/ prefix: ${prefix}`)
		let params = {
			url: $form.attr('action'),
			data: formData,
			method: 'POST',
			contentType: false,
			processData: false,
		}
		this._prefix = prefix
		console.log(params)
		$.ajax(params)
			.done(response => this.callbackOnSucceededAjaxRequest(response))
			.fail((jqXHR, textStatus, errorThrown) => this.callbackOnFailedAjaxRequest(jqXHR, textStatus, errorThrown))
			.always(() => {
				this._post = false
				// clicked classの削除
				$('button[data-multipart-form-data]').removeClass('clicked')
			})
	}


	/**
	 * $.ajax 成功コールバック
	 *
	 * @memberof FormModel
	 * @return {undefined}
	 */
	callbackOnSucceededAjaxRequest(response) {
		console.log(response)
		$('body').append(Template.completeModal(response.message ? response.message : '処理が正常に終了しました。'))
		const completeModalElement = document.getElementById('modal-success')
		const completeModal = bootstrap.Modal.getInstance(completeModalElement) ?? new bootstrap.Modal(completeModalElement)
		completeModal.show()
		completeModalElement.addEventListener('hidden.bs.modal', () => {
			if (this._prefix != 'mrc') response.result.redirect_url && (location.href = response.result.redirect_url)
			completeModalElement.remove();
			this._listener.trigger('registerSupporterComplete');
		}, { once: true })
	};


	/**
	 * $.ajax エラーコールバック
	 *
	 * @memberof FormModel
	 * @return {undefined}
	 */
	callbackOnFailedAjaxRequest(jqXHR, textStatus, errorThrown) {
		console.log(`fail / responseJSON.message: ${jqXHR.responseJSON.message}`)
		console.log(`fail / jqXHR.status: ${jqXHR.status} / textStatus: ${textStatus}`)
		console.log(`fail / errorThrown: ${errorThrown}`)
		$('body').append(Template.errorModal(`処理に問題が発生しました。${jqXHR.responseJSON.message ? `<br>${jqXHR.responseJSON.message}` : ''}`))
		const errorModalElement = document.getElementById('modal-error')
		const errorModal = bootstrap.Modal.getInstance(errorModalElement) ?? new bootstrap.Modal(errorModalElement)
		errorModal.show()
		switch (jqXHR.status) {
			case 401: {
				errorModalElement.addEventListener('hidden.bs.modal', () => location.reload(), { once: true })
				break
			}
			default: {
				errorModalElement.addEventListener('hidden.bs.modal', () => {
					errorModal.dispose()
					errorModalElement.remove()
				}, { once: true })
			}
		}
	};


	/**
	 * 日本連盟内部メモ送信
	 *
	 * @memberof FormModel
	 * @param {FormData} formData - フォームデータ
	 * @return {undefined}
	 */
	updateInternalMemo(formData) {
		if (this._post) return;
		console.log(`FormModel.updateInternalMemo`);
		Common.showLoading();
		this._post = true;
		let params = {};
		const url = window.const.API_URL.UPDATE_INTERNAL_MEMO;
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onUpdateInternalMemo.bind(this));
	};


	/**
	 *  日本連盟内部メモ送信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onUpdateInternalMemo(data, textStatus) {
		console.log('FormModel.onUpdateInternalMemo');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				Common.showCompleteModal('更新が完了しました。');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onUpdateInternalMemo): ${textStatus}`);
		}
		this._jqXHR = null;
	};

	/**
	 * 出納帳や組織画面のメモ送信
	 *
	 * @memberof FormModel
	 * @param {FormData} formData - フォームデータ
	 * @return {undefined}
	 */
	updateJapanCouncilNotes(formData) {
		if (this._post) return;
		console.log(`FormModel.updateJapanCouncilNotes`);
		Common.showLoading();
		this._post = true;
		let params = {};
		const url = window.const.API_URL.UPDATE_JAPAN_COUNCIL_NOTES;
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onUpdateJapanCouncilNotes.bind(this));
	};


	/**
	 *  出納帳や組織画面のメモ送信完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onUpdateJapanCouncilNotes(data, textStatus) {
		console.log('FormModel.onUpdateInternalMemo');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				Common.showCompleteModal('更新が完了しました。');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onUpdateJapanCouncilNotes): ${textStatus}`);
		}
		this._jqXHR = null;
	};
	/**
	 * 移籍対象取得
	 *
	 * @memberof FormModel
	 * @return {undefined}
	 */
	getTransferTarget() {
		if (this._post) return;
		console.log(`FormModel.getTransferTarget`);
		Common.showLoading();
		this._post = true;
		const applyYear = $('[name=apply_type]:checked').val();
		const memberType = $('[name=member_type]:checked').val();
		let formData = new FormData();
		formData.append('apply_type', applyYear);
		formData.append('member_type', memberType);
		let params = {};
		const url = window.const.API_URL.GET_TRANSFER_TARGET;
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetTransferTarget.bind(this));
	};


	/**
	 *  移籍対象取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetTransferTarget(data, textStatus) {
		console.log('FormModel.onGetTransferTarget');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getTransferTargetComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetTransferTarget): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * 移籍対象取得
	 *
	 * @memberof FormModel
	 * @return {undefined}
	 */
	getAdditionalTitleTarget() {
		if (this._post) return;
		console.log(`FormModel.getAdditionalTitleTarget`);
		Common.showLoading();
		this._post = true;
		const applyYear = $('[name=apply_type]:checked').val();
		let formData = new FormData();
		formData.append('apply_type', applyYear);
		let params = {};
		const url = window.const.API_URL.GET_ADDITIONAL_TITLE_TARGET;
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetAdditionalTitleTarget.bind(this));
	};


	/**
	 *  移籍対象取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @return {undefined}
	 */
	onGetAdditionalTitleTarget(data, textStatus) {
		console.log('FormModel.onGetAdditionalTitleTarget');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.code;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (textStatus === 'success') {
			if (this._code !== 0) {
				this._post = false;
				Common.showErrorModal(this._message);
			} else {
				this._post = false;
				this._listener.trigger('getAdditionalTitleTargetComplete');
			}
		} else {
			if (data.status === 401) {
				Common.show401Modal();
				return;
			}
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetAdditionalTitleTarget): ${textStatus}`);
		}
		this._jqXHR = null;
	};


	/**
	 * listener on
	 *
	 * @memberof FormModel
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listner off
	 *
	 * @memberof FormModel
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};
}
